import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import VirtualMainForm from "../../components/virtualmainform/VirtualMainForm";
import VirtualSubForm from "../../components/virtualsubform/VirtualSubForm";
import "./VirtualBuilder.css";
import axios from "axios";

const VirtualBuilder = (props) => {
  const { id } = useParams();

  const [predefinedStartPos, setPredefinedStartPos] = useState([]);
  const [positionOptions, setPositionOptions] = useState([]);
  const [subProbIds, setSubProbIds] = useState([]);

  useEffect(() => {
    props.actSidebar(false);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_programs/get-virtual-builder-data", {})
      .then((res) => {
        if (res.data.responseData) {
          var pos = [];
          var ids = [];
          for (var options of res.data.responseData[0]) {
            pos.push({ value: options.name });
          }
          setPredefinedStartPos(res.data.responseData[0]);
          setPositionOptions(pos);

          for (var id of res.data.responseData[1]) {
            ids.push({ value: id.id });
          }
          setSubProbIds(ids);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
    if (id) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        axios
          .post(window.ajaxLink + "cloud_programs/get-virtual-activity", { id })
          .then((res) => {
            if (res.data.responseData) {
              var data = JSON.parse(res.data.responseData.virtual_json);
              setData(data.customVariables);
              setVirtualState(JSON.parse(res.data.responseData.virtual_json));
              var exrTemp = res.data.responseData.exerciseTemplate;
              setVirtualVal({
                exerciseType: exrTemp.exercise_type,
                exerciseLevel: exrTemp.exercise_level,
                timeRepBased: exrTemp.time_rep_based,
                defaultTime: "",
                defaultSets: exrTemp.multiple_sets,
                defaultReps: exrTemp.reps,
                defaultHoldTime: exrTemp.hold_in_seconds,
                virtualVideoUrl: res.data.responseData.demo_video,
                virtualImageUrl: res.data.responseData.image,
                subProblemId: exrTemp.sub_problem_id,
                time_rep_based: exrTemp.time_rep_based,
                predefined_start_pos:
                  res.data.responseData.predefined_start_position,
              });
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
              props.checkLoggedIn(false);
            }
          });
      }
    }
  }, [props, id]);

  const [virtualVal, setVirtualVal] = useState({
    exerciseType: "",
    exerciseLevel: "",
    defaultTime: "",
    defaultSets: "",
    defaultReps: "",
    defaultHoldTime: "",
    virtualVideoUrl: "",
    virtualImageUrl: "",
    subProblemId: "",
    time_rep_based: "",
    predefined_start_pos: "",
  });

  const getVirtualStates = (state, val) => {
    var virtValObj = { ...virtualVal };
    virtValObj[state] = val;
    setVirtualVal(virtValObj);
  };

  const [virtualState, setVirtualState] = useState({
    key: "",
    displayName: "",
    isHold: "",
    startPosition: {},
    targetLandmarks: null,
    fractions: {
      minFraction: 0.3,
      holdFraction: 0.3,
      returnFraction: 0.3,
      repEndFraction: 0.25,
    },
    currentStep: 0,
    detectAnyStep: false,
    exerciseSteps: [
      {
        detectType: "",
        targetPosition: "",
        minimumLevel: 0.7,
        detectAny: false,
        cameraRotation: "",
        repDetect: [
          {
            requirements: [],
            extensions: [],
          },
        ],
        positionDetect: [],
        onScreenGraphics: [],
        successActions: [],
      },
    ],
    customVariables: {},
  });

  const [mediaPipePoints] = useState([
    { value: "Nose - 0", key: 0 },
    { value: "Left Eye Inner - 1", key: 1 },
    { value: "Left Eye - 2", key: 2 },
    { value: "Left Eye Outer - 3", key: 3 },
    { value: "Right Eye Inner - 4", key: 4 },
    { value: "Right Eye - 5", key: 5 },
    { value: "Right Eye Outer - 6", key: 6 },
    { value: "Left Ear - 7", key: 7 },
    { value: "Right Ear - 8", key: 8 },
    { value: "Mouth Left - 9", key: 9 },
    { value: "Mouth Right - 10", key: 10 },
    { value: "Left Shoulder - 11", key: 11 },
    { value: "Right Shoulder - 12", key: 12 },
    { value: "Left Elbow - 13", key: 13 },
    { value: "Right Elbow - 14", key: 14 },
    { value: "Left Wrist - 15", key: 15 },
    { value: "Right Wrist - 16", key: 16 },
    { value: "Left Pinky - 17", key: 17 },
    { value: "Right Pinky - 18", key: 18 },
    { value: "Left Index - 19", key: 19 },
    { value: "Right Index - 20", key: 20 },
    { value: "Left Thumb - 21", key: 21 },
    { value: "Right Thumb - 22", key: 22 },
    { value: "Left Hip - 23", key: 23 },
    { value: "Right Hip - 24", key: 24 },
    { value: "Left Knee - 25", key: 25 },
    { value: "Right Knee - 26", key: 26 },
    { value: "Left Ankle - 27", key: 27 },
    { value: "Right Ankle - 28", key: 28 },
    { value: "Left Heel - 29", key: 29 },
    { value: "Right Heel - 30", key: 30 },
    { value: "Left Foot Index - 31", key: 31 },
    { value: "Right Foot Index - 32", key: 32 },
  ]);

  const [joints] = useState([
    { value: "Left Shoulder ", key: "leftShoulder" },
    { value: "Right Shoulder", key: "rightShoulder" },
    { value: "Left Hip", key: "leftHip" },
    { value: "Right Hip", key: "rightHip" },
    { value: "Left Elbow", key: "leftElbow" },
    { value: "Right Elbow", key: "rightElbow" },
    { value: "Left Knee", key: "leftKnee" },
    { value: "Right Knee", key: "rightKnee" },
    { value: "Left Ankle", key: "leftAnkle" },
    { value: "Right Ankle", key: "rightAnkle" },
  ]);

  const [isInAdd, setAdd] = useState(false);
  const [addType, setAddType] = useState("");
  const [stepModified, setStepModified] = useState(-1);

  const openCloseSubform = (type, stepMod) => {
    if (isInAdd) {
      setAddType("");
      setStepModified(stepMod);
    } else {
      setAddType(type);
      setStepModified(stepMod);
    }
    setAdd(!isInAdd);
  };

  const addStartPosition = (opt, val) => {
    var virtualObj = { ...virtualState };
    var virtValObj1 = { ...virtualVal };

    var filterJson = JSON.parse(
      predefinedStartPos.filter((item) => {
        return item.name === val;
      })[0].start_position_json
    );
    virtValObj1.predefined_start_pos = val;
    virtualObj.startPosition = filterJson;
    setVirtualState(virtualObj);
    setVirtualVal(virtValObj1);
  };

  const addConditions = () => {
    var virtualObj = { ...virtualState };
    let requirements = {
      cType: "",
      landmarks: ["", ""],
      tolerance: "",
    };
    virtualObj.exerciseSteps[0].repDetect[0].requirements.push(requirements);
    setVirtualState(virtualObj);
  };

  const addExtensions = (point) => {
    var virtualObj = { ...virtualState };

    if (point[0] === "point") {
      let extensions = {
        extensionPoint: "",
        startVal: "",
        targetVal: "",
      };
      virtualObj.exerciseSteps[0].repDetect[0].extensions.push(extensions);
      setVirtualState(virtualObj);
    } else if (point[0] === "angle") {
      let extensions = {
        extensionAngle: ["", "", ""],
        startVal: "",
        targetVal: "",
      };
      virtualObj.exerciseSteps[0].repDetect[0].extensions.push(extensions);
      setVirtualState(virtualObj);
    }
  };

  const addExerciseStep = () => {
    var virtualObj = { ...virtualState };
    let exrStep = {
      type: "",
      direction: "",
      relativeTo: "",
      itemIndex: 0,
      itemIndexXY: "",
      detectPoint: ["", ""],
      condition: "",
      singleActions: [],
    };

    virtualObj.exerciseSteps[0].positionDetect.push(exrStep);
    setVirtualState(virtualObj);
  };

  const removeExerciseStep = (inx) => {
    var virtualObj = { ...virtualState };
    virtualObj.exerciseSteps[0].positionDetect.splice(inx, 1);
    setVirtualState(virtualObj);
  };

  const addGraphOrAction = (vals) => {
    var virtualObj = { ...virtualState };
    if (vals[2] === "onScreenGraphics") {
      var valuesToAdd = {
        graphicType: "",
        graphicData: {
          x1: { start: ["mediaPoint", 0] },
          y1: { start: ["mediaPoint", 0] },
          x2: { start: ["mediaPoint", 0] },
          y2: { start: ["mediaPoint", 0] },
        },
      };
      virtualObj[vals[0]][0][vals[2]].push(valuesToAdd);
      setVirtualState(virtualObj);
    } else if (vals[2] === "singleActions") {
      valuesToAdd = {
        action: "",
        value: "",
        //delayAction: 0,
      };
    } else if (vals[2] === "angleMonitoring") {
      valuesToAdd = {
        name: "",
        angle: [0, 0, 0],
        errorAngle: "",
        criticalAngle: "",
      };
    } else if (vals[2] === "positionDetect") {
      valuesToAdd = getUniquePoseValues(vals[3]);
    }
    if (vals[2] === "singleActions") {
      virtualObj[vals[0]][0][vals[3]][vals[1]][vals[2]].push(valuesToAdd);
      setVirtualState(virtualObj);
    }
  };

  const checkForNum = (val) => {
    let reg = /[^-?][^0-9]/;
    var tstreg = reg.test(val);
    if (tstreg) {
      return false;
    } else {
      if (val !== "x" && val !== "y") {
        val = parseInt(val);
      }
      if (isNaN(val) && val !== "x" && val !== "y") {
        val = 0;
      }
    }
    return val;
  };

  const checkForDecNum = (val) => {
    let reg = /^\d*(\.\d+)?$/;
    var tstreg = reg.test(val);
    if (!tstreg) {
      return false;
    } else {
      val = parseFloat(val);
      if (isNaN(val)) {
        val = 0;
      }
    }
    return val;
  };

  const [data, setData] = useState({});

  const handleInputChange = (e, index, fieldType) => {
    var virtualObj = { ...virtualState };
    const { value } = e.target;

    setData((prevData) => {
      const newData = { ...prevData };

      if (fieldType === "key") {
        if (newData[value] && index !== value) {
          const newKey = generateUniqueKey(newData, value);
          const itemValue = newData[index];
          delete newData[index];
          newData[newKey] = itemValue;
        } else {
          newData[value] = newData[index];
          delete newData[index];
        }
      } else if (fieldType === "value") {
        if (isNaN(value)) {
          if (value === "true" || value === "True") {
            newData[index] = true;
          } else if (value === "false" || value === "False") {
            newData[index] = false;
          } else {
            newData[index] = value;
          }
        } else {
          newData[index] = parseInt(value);
        }
      }

      virtualObj.customVariables = newData;
      return newData;
    });

    setVirtualState(virtualObj);
  };

  const generateUniqueKey = (data, originalKey) => {
    let uniqueKey = originalKey;
    let count = 1;
    while (data[uniqueKey]) {
      uniqueKey = `${originalKey}${count}`;
      count++;
    }
    return uniqueKey;
  };

  const handleAddData = () => {
    setData((prevData) => {
      const newData = { ...prevData };
      const keys = Object.keys(newData);
      const newKey1 =
        keys.length > 0 ? (parseInt(keys[keys.length - 1]) + 1).toString() : "";
      const newKey2 = newKey1 !== "" ? (parseInt(newKey1) + 1).toString() : "";
      newData[newKey1] = "";
      newData[newKey2] = "";
      return newData;
    });
  };

  const handleTopVals = (passedVal, val, num) => {
    var virtualObj = { ...virtualState };
    if (num) {
      val = checkForNum(val);
      if (val === false) {
        return false;
      }
    }
    virtualObj[passedVal] = val;
    setVirtualState(virtualObj);
  };

  const handleObjVals = (valObj, val, num) => {
    var virtualObj = { ...virtualState };
    if (num) {
      val = checkForNum(val);
      if (val === false) {
        return false;
      }
    }
    if (valObj[1] === "targetLevel") {
      if (val > 100) {
        return false;
      }
      val = val / 100;
    }
    virtualObj[valObj[0]][valObj[1]] = val;
    setVirtualState(virtualObj);
  };

  const switchTypes = (inx, val) => {
    var virtualObj = { ...virtualState };
    if (virtualObj[inx[0]][inx[1]][inx[2]] !== val) {
      if (val === "targetPosition") {
        var exrStep = {
          detectType: "targetPosition",
          targetPosition: null,
          minimumLevel: 0,
          onScreenGraphics: virtualObj[inx[0]][inx[1]].onScreenGraphics
            ? virtualObj[inx[0]][inx[1]].onScreenGraphics
            : [],
          singleActions: virtualObj[inx[0]][inx[1]].singleActions
            ? virtualObj[inx[0]][inx[1]].singleActions
            : [],
          angleMonitoring: virtualObj[inx[0]][inx[1]].angleMonitoring
            ? virtualObj[inx[0]][inx[1]].angleMonitoring
            : [],
        };
      } else if (val === "positionDetect") {
        exrStep = {
          detectType: "positionDetect",
          detectAny: true,
          targetPosition: virtualObj[inx[0]][inx[1]].targetPosition,
          minimumLevel: virtualObj[inx[0]][inx[1]].minimumLevel,
          positionDetect: [],
          onScreenGraphics: virtualObj[inx[0]][inx[1]].onScreenGraphics
            ? virtualObj[inx[0]][inx[1]].onScreenGraphics
            : [],
          singleActions: virtualObj[inx[0]][inx[1]].singleActions
            ? virtualObj[inx[0]][inx[1]].singleActions
            : [],
          angleMonitoring: virtualObj[inx[0]][inx[1]].angleMonitoring
            ? virtualObj[inx[0]][inx[1]].angleMonitoring
            : [],
        };
      }
      virtualObj[inx[0]][inx[1]] = exrStep;
    }
    setVirtualState(virtualObj);
  };

  const handleArrVals = (valArr, val, num) => {
    var virtualObj = { ...virtualState };

    if (val === "Any") {
      val = true;
    }
    if (val === "All") {
      val = false;
    }

    if (num) {
      if (typeof val === "object") {
        var key = JSON.stringify(val).split(`"`)[1];
        var finalVal = checkForNum(val[key]);
        if (finalVal !== false) {
          finalVal = parseInt(val[key]);
        }
      } else {
        finalVal = checkForNum(val);
      }

      if (finalVal === false) {
        return false;
      }
      if (valArr[2] === "minimumLevel") {
        if (finalVal > 100) {
          return false;
        }
        finalVal = finalVal / 100;
      }
    } else if (typeof val === "string" && valArr[1] !== "targetJoints") {
      finalVal = val.split(" ");
      finalVal[0] = finalVal[0].toLowerCase();
      finalVal = finalVal.join("");
      if (valArr[2] === "detectType") {
        switchTypes(valArr, finalVal);
        return false;
      }
    }

    virtualObj[valArr[0]][valArr[1]][valArr[2]] = finalVal || val;
    setVirtualState(virtualObj);
  };

  const handleNewArrVals = (valArr, val) => {
    var virtualObj = { ...virtualState };
    if (valArr[2] === "requirements") {
      if (val === "MustBeAtSameY" || val === "MustBeHigherThan") {
        virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][valArr[3]].cType =
          val;
        setVirtualState(virtualObj);
      }

      for (var joint of joints) {
        if (val === joint.key) {
          virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][
            valArr[3]
          ].landmarks[valArr[4]] = val;
          setVirtualState(virtualObj);
        }
      }

      if (typeof val === "number") {
        virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][valArr[3]].tolerance =
          val;
        setVirtualState(virtualObj);
      }
    } else if (valArr[2] === "extensions") {
      for (var joint2 of joints) {
        if (val === joint2.key) {
          virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][
            valArr[3]
          ].extensionPoint = val;
          setVirtualState(virtualObj);
        }
      }
      if (typeof val === "number" && valArr[4] === "start") {
        virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][valArr[3]].startVal =
          val;
        setVirtualState(virtualObj);
      } else if (typeof val === "number" && valArr[4] === "target") {
        virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][valArr[3]].targetVal =
          val;
        setVirtualState(virtualObj);
      }
    }

    if (valArr[0] && valArr[0] === "stepType") {
      virtualObj.exerciseSteps[0].detectType = val;
      setVirtualState(virtualObj);
    } else if (valArr[0] && valArr[0] === "targetPosition") {
      virtualObj.exerciseSteps[0].targetPosition = val;
      setVirtualState(virtualObj);
    } else if (valArr[0] && valArr[0] === "minimumLevel") {
      virtualObj.exerciseSteps[0].minimumLevel = val;
      setVirtualState(virtualObj);
    } else if (valArr[0] && valArr[0] === "detectAny") {
      virtualObj.exerciseSteps[0].detectAny = val;
      setVirtualState(virtualObj);
    } else if (valArr[0] && valArr[0] === "cameraRotation") {
      virtualObj.exerciseSteps[0].cameraRotation = val;
      setVirtualState(virtualObj);
    }

    if (valArr[4] === "angle1") {
      virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][
        valArr[3]
      ].extensionAngle[0] = val;
      setVirtualState(virtualObj);
    } else if (valArr[4] === "angle2") {
      virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][
        valArr[3]
      ].extensionAngle[1] = val;
      setVirtualState(virtualObj);
    } else if (valArr[4] === "angle3") {
      virtualObj[valArr[0]][0][valArr[1]][0][valArr[2]][
        valArr[3]
      ].extensionAngle[2] = val;
      setVirtualState(virtualObj);
    }
  };

  const handleArrSubVals = (valArr, val, num) => {
    var virtualObj = { ...virtualState };

    if (val === "True" || val === "true") {
      val = true;
    }
    if (val === "False" || val === "false") {
      val = false;
    }

    if (num) {
      if (valArr[4] === "graphicData") {
        var key = JSON.stringify(val).split(`"`)[1];
        var finalVal = checkForNum(val[key][1]);
        if (finalVal !== false) {
          finalVal = parseInt(val[key][1]);
        }
      } else if (valArr[5] && valArr[5] === "multiply") {
        finalVal = checkForDecNum(val);
      } else if (valArr[4] === "detectionGrow" && valArr[5] === 0) {
        finalVal = checkForDecNum(val);
      } else {
        finalVal = checkForNum(val);
      }

      if (finalVal === false) {
        return false;
      }
      if (valArr[2] === "minimumLevel") {
        if (finalVal > 100) {
          return false;
        }
        finalVal = finalVal / 100;
      }
    } else if (
      !(
        valArr[2] === "angleMonitoring" ||
        valArr[2] === "positionDetect" ||
        valArr[4] === "item" ||
        valArr[4] === "value" ||
        valArr[4] === "subObject" ||
        valArr[4] === "index1" ||
        valArr[4] === "index2" ||
        valArr[4] === "index3" ||
        valArr[4] === "index4"
      ) &&
      typeof val === "string"
    ) {
      finalVal = val.split(" ");
      finalVal[0] = finalVal[0].toLowerCase();
      finalVal = finalVal.join("");
      if (valArr[2] === "detectType") {
        switchTypes(valArr, finalVal);
        return false;
      }
    } else if (
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]] &&
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
        .action === "playAudio" &&
      valArr[4] === "value"
    ) {
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
        valArr[3]
      ].value = val;
      setVirtualState(virtualObj);
    } else if (
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]] &&
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
        .action === "changeVariable" &&
      valArr[4] === "item"
    ) {
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
        valArr[3]
      ].item = val;
      setVirtualState(virtualObj);
    } else if (
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]] &&
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
        .action === "changeVariable" &&
      valArr[5] === "dropDown"
    ) {
      if (val === true || val === false) {
        virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
          valArr[3]
        ].value = val;
        setVirtualState(virtualObj);
      } else {
        virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
          valArr[3]
        ].value = parseInt(val);
        setVirtualState(virtualObj);
      }
    } else if (
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]] &&
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
        .action === "changeMainObject" &&
      valArr[4] === "value"
    ) {
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
        valArr[3]
      ].value = val;
      setVirtualState(virtualObj);
    } else if (
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]] &&
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
        .action === "showCircleAnimation" &&
      valArr[4] === "value"
    ) {
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
        valArr[3]
      ].item = val;
      setVirtualState(virtualObj);
    } else if (
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]] &&
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
        .action === "repIncrease" &&
      valArr[4] === "value"
    ) {
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][
        valArr[3]
      ].value = val;
      setVirtualState(virtualObj);
    } else {
      finalVal = val;
    }

    if (valArr[2] === "singleActions" && valArr[4] === "action") {
      var actionsObj = getUniquePoseValues(
        finalVal,
        virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]]
      );
      virtualObj[valArr[0]][0].positionDetect[valArr[1]][valArr[2]][valArr[3]] =
        actionsObj;
    }
    if (valArr[2] === "positionDetect" && valArr[4] === "type") {
      var poseObj = getUniquePoseValues(val);
      virtualObj[valArr[0]][0][valArr[2]][valArr[1]] = poseObj;
    }
    if (valArr[4] === "compareDirection") {
      var subPointObj = getUniquePoseValues(
        val,
        virtualObj[valArr[0]][valArr[1]][valArr[2]][valArr[3]]
      );
      virtualObj[valArr[0]][valArr[1]][valArr[2]][valArr[3]] = subPointObj;
    }
    if (valArr[4] === "graphicData") {
      virtualObj.exerciseSteps[valArr[1]].onScreenGraphics[
        valArr[3]
      ].graphicData[key].start[1] = finalVal;
    } else if (
      valArr[4] === "angle" ||
      valArr[4] === "distance1" ||
      valArr[4] === "distance2" ||
      valArr[4] === "detectionGrow" ||
      (valArr[4] === "detectPoints" && valArr[5] !== undefined) ||
      (valArr[4] === "detectPoint" && valArr[5] !== undefined)
    ) {
      virtualObj[valArr[0]][valArr[1]][valArr[2]][valArr[3]][valArr[4]][
        valArr[5]
      ] = val;
      if (valArr[5] === "compareType") {
        var subPoseObj = getUniquePoseValues(
          val,
          virtualObj[valArr[0]][valArr[1]][valArr[2]][valArr[3]][valArr[4]]
        );
        virtualObj[valArr[0]][valArr[1]][valArr[2]][valArr[3]][valArr[4]] =
          subPoseObj;
      }
    } else if (
      valArr[4] === "direction" ||
      valArr[4] === "relativeTo" ||
      valArr[4] === "itemIndex" ||
      valArr[4] === "itemIndexXY" ||
      valArr[4] === "detectPoint" ||
      valArr[4] === "condition"
    ) {
      virtualObj[valArr[0]][0][valArr[2]][valArr[1]][valArr[4]] = finalVal;
    }

    if (valArr[4] === "graphicType" && val !== "image") {
      handleGraphicType([valArr[1], valArr[3]]);
    }
    if (valArr[4] === "graphicType") {
      switchGraphObject([valArr[1], valArr[3]], val);
    }

    setVirtualState(virtualObj);
  };

  const switchGraphObject = (keys, val) => {
    var virtualObj = { ...virtualState };
    if (
      val === "Circle" ||
      val === "Animated Circle" ||
      val === "Floor Circle"
    ) {
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.innerColor;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.innerSize;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.outerColor;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.outerSize;
    } else if (val === "Line") {
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.color;
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[
        keys[1]
      ].graphicData.innerColor = "";
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[
        keys[1]
      ].graphicData.innerSize = 0;
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[
        keys[1]
      ].graphicData.outerColor = "";
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[
        keys[1]
      ].graphicData.outerSize = 0;
    } else {
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.color;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.innerColor;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.innerSize;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.outerColor;
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .graphicData.outerSize;
    }
    virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicType =
      val;
    setVirtualState(virtualObj);
  };

  const handleGraphicType = (keys, val, isNum) => {
    if (isNum) {
      val = checkForNum(val);
      if (val === false) {
        return false;
      }
    }
    var virtualObj = { ...virtualState };
    if (val === undefined) {
      delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
        .imageUrl;
    } else if (keys[2] === "imageUrl") {
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]][keys[2]] =
        val;
      if (val === "") {
        delete virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]]
          .imageUrl;
      }
    } else {
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicData[
        keys[2]
      ] = val;
    }

    setVirtualState(virtualObj);
  };

  const handleGraphicPoints = (keys, val) => {
    var virtualObj = { ...virtualState };
    if (keys[3] === "offset" && keys[4] === 3) {
      val = checkForDecNum(val);
      if (checkForDecNum(val) === false) {
        return false;
      }
    } else if (checkForNum(val) === false) {
      val = val.split(" ");
      if (val[1] === "Pipe" && val[2] === "Point") {
        val[1] = "";
      }
      val[0] = val[0].toLowerCase();
      val = val.join("");
    } else {
      val = checkForNum(val);
    }

    if (
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicData[
        keys[2]
      ][keys[3]] === undefined
    ) {
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicData[
        keys[2]
      ][keys[3]] = [keys[4], 0];
    }
    if (
      keys[3] === "offset" &&
      keys[4] === 0 &&
      val !== "pixel" &&
      val !== "screenPercent"
    ) {
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicData[
        keys[2]
      ][keys[3]] = ["", "x", 0, 0, 0];
    }
    virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicData[
      keys[2]
    ][keys[3]][keys[4]] = val;

    setVirtualState(virtualObj);
  };

  const handleGraphicStyle = (keys, val) => {
    var virtualObj = { ...virtualState };
    val = checkForNum(val);
    if (val === false) {
      return false;
    }
    if (keys[2] !== "lineSize") {
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicStyle[
        keys[2]
      ][keys[3]] = val > 255 ? 255 : val;
    } else {
      virtualObj.exerciseSteps[keys[0]].onScreenGraphics[keys[1]].graphicStyle[
        keys[2]
      ] = val;
    }
    setVirtualState(virtualObj);
  };

  const handleActionObjectNodes = (action, item) => {
    var virtualObj = { ...virtualState };
    var objectBasis =
      virtualObj.exerciseSteps[0].positionDetect[action[0]].singleActions[
        action[1]
      ];
    var overwrite = {};
    if (action[2] === "subObject" && item === "exerciseSteps") {
      overwrite = {
        action: objectBasis.action,
        subObject: objectBasis.subObject,
        itemIndex: objectBasis.itemIndex || 0,
        index1: "",
        index2: 0,
        value: objectBasis.value,
      };
      objectBasis = overwrite;
    } else if (action[2] === "subObject" && item !== "exerciseSteps") {
      overwrite = {
        action: objectBasis.action,
        subObject: objectBasis.subObject,
        itemIndex: objectBasis.itemIndex,
        index1: "onScreenGraphics",
        index2: objectBasis.index2,
        index3: "graphicData",
        index4: objectBasis.index4,
        value: objectBasis.value || "",
      };
      objectBasis = overwrite;
    }
    if (
      action[2] === "index1" &&
      (item === "positionDetect" || item === "onScreenGraphics")
    ) {
      overwrite = {
        action: objectBasis.action,
        subObject: objectBasis.subObject,
        itemIndex: objectBasis.itemIndex,
        index1: objectBasis.index1,
        index2: 0,
        index3: "",
        value: objectBasis.value || "",
      };
      objectBasis = overwrite;
    } else if (
      action[2] === "index1" &&
      !(item === "positionDetect" || item === "onScreenGraphics")
    ) {
      overwrite = {
        action: objectBasis.action,
        subObject: objectBasis.subObject,
        itemIndex: objectBasis.itemIndex,
        index1: objectBasis.index1,
        value: objectBasis.value || "",
      };
      objectBasis = overwrite;
    }

    if (
      action[2] === "index3" &&
      (item === "detectPoints" || item === "graphicData")
    ) {
      overwrite = {
        action: objectBasis.action,
        subObject: objectBasis.subObject,
        itemIndex: objectBasis.itemIndex,
        index1: objectBasis.index1,
        index2: objectBasis.index2,
        index3: item,
        index4: "",
        value: objectBasis.value,
      };
      objectBasis = overwrite;
    } else if (
      action[2] === "index3" &&
      !(item === "detectPoints" || item === "graphicData")
    ) {
      overwrite = {
        action: objectBasis.action,
        subObject: objectBasis.subObject,
        itemIndex: objectBasis.itemIndex,
        index1: objectBasis.index1,
        index2: objectBasis.index2,
        index3: item,
        value: objectBasis.value,
      };
      objectBasis = overwrite;
    }
    if (action[2] === "deleteAction" && item === true) {
      delete virtualObj.exerciseSteps[0].positionDetect[action[0]]
        .singleActions[action[1]];
      var filteredObj =
        virtualObj.exerciseSteps[0].positionDetect[0].singleActions.filter(
          (item) => {
            return item != null;
          }
        );
      virtualObj.exerciseSteps[0].positionDetect[0].singleActions = filteredObj;
      setVirtualState(virtualObj);
    } else {
      objectBasis[action[2]] = item;
      virtualObj.exerciseSteps[action[0]].positionDetect[0].singleActions[
        action[1]
      ] = objectBasis;
      setVirtualState(virtualObj);
    }
  };

  const getUniquePoseValues = (type, oldObj) => {
    var newObj = {};
    if (type === "crossLine") {
      newObj = {
        type: type,
        direction: "x",
        relativeTo: "graphic",
        itemIndex: 0,
        itemIndexXY: "x1",
        detectPoint: [0, "x"],
        condition: "none",
        singleActions: [],
        detectACState: ["", ""],
        actionCondition: ["", false],
        singleNoActions: [{ action: "", item: "", value: true }],
        actionNoCondition: ["", false],
      };
    } else if (type === "comparePoints") {
      newObj = {
        type: type,
        distance1: {
          title: "",
          compareType: "mediaPointDistance",
          point1: 0,
          point2: 0,
          direction: "x",
          multiply: 1,
        },
        distance2: {
          title: "",
          compareType: "mediaPointDistance",
          point1: 0,
          point2: 0,
          direction: "x",
          multiply: 1,
        },
        condition: "none",
      };
    } else if (type === "insideGraphic") {
      newObj = {
        type: type,
        itemIndex: 0,
        detectPoints: [0, 0, 0, 0, 0, 0],
        compareDirection: "x",
        detectionGrow: [],
        condition: "none",
      };
    } else if (type === "mediaPointDistance") {
      newObj = {
        title: oldObj.title,
        compareType: type,
        point1: 0,
        point2: 0,
        direction: "x",
        multiply: parseInt(oldObj.multiply),
      };
    } else if (type === "userHeight") {
      newObj = {
        title: oldObj.title,
        compareType: type,
        multiply: parseInt(oldObj.multiply),
      };
    } else if (type === "x" || type === "y") {
      // newObj = {
      //   type: oldObj.type,
      //   itemIndex: oldObj.itemIndex,
      //   detectPoints: 0,
      //   compareDirection: type,
      //   detectionGrow: oldObj.detectionGrow,
      //   condition: oldObj.condition,
      // };
      newObj = oldObj;
    } else if (type === "inside both") {
      // newObj = {
      //   type: oldObj.type,
      //   itemIndex: oldObj.itemIndex,
      //   detectPoints: [0, 0],
      //   compareDirection: type,
      //   detectionGrow: oldObj.detectionGrow,
      //   condition: oldObj.condition,
      // };
      newObj = oldObj;
    } else if (type === "repIncrease") {
      newObj = {
        action: type,
        value: 0,
      };
    } else if (type === "counter" || type === "changeObject") {
      newObj = {
        action: type,
        item: "",
        value: 0,
      };
    } else if (type === "changeVariable" || type === "changeStep") {
      newObj = {
        action: type,
        item: "",
        value: "",
      };
    } else if (type === "playAudio") {
      newObj = {
        action: type,
        value: "",
      };
    } else if (type === "changeMainObject") {
      newObj = {
        action: type,
        subObject: "",
        itemIndex: 0,
        index1: "onScreenGraphics",
        index2: 0,
        index3: "graphicData",
        index4: "",
        value: "",
      };
    } else if (type === "changeGraphic") {
      newObj = {
        action: type,
        itemIndex: 0,
        index1: null,
        index2: null,
        index3: null,
        value: "",
      };
    } else if (type === "showCircleAnimation") {
      newObj = {
        action: type,
        item: 0,
      };
    } else if (type === "doActions") {
      newObj = {
        action: type,
        item: 0,
      };
    } else if (type === "acAction") {
      newObj = {
        action: type,
        item: 0,
      };
    }
    return newObj;
  };

  const [saveUnclickable, setSaveUnlickable] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  useEffect(() => {
    setShowConfirmation(false);
    setErrorStep(false);
  }, [virtualState]);

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);
  const [errorStep, setErrorStep] = useState(false);

  const saveVirtualObj = () => {
    if (virtualState.exerciseSteps.length > 0) {
      setErrorStep(false);
      if (!virtualState.isHold) {
        delete virtualState.isHold;
      }
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_programs/save-virtual-activity", {
          id: id ? id : 0,
          name: virtualState.displayName,
          virtual_json: JSON.stringify(virtualState),
          virtualData: virtualVal,
        })
        .then((res) => {
          if (res.data.responseData) {
            if (!id) {
              setSaveUnlickable(true);
            }
            setShowConfirmation(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setErrorPopUp("Please add at least one step.");
      setErrorStep(true);
      return false;
    }
  };

  //console.log(JSON.stringify(virtualState));

  return (
    <div>
      <div className="prog_det_top_hold vt_top">
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            className={
              "prog_det_title vt_title_reduce" +
              (showConfirmation ? " vt_title_saved_reduce" : "")
            }
          >
            Virtual Builder
          </div>
          <div
            className={
              "prog_edit_btn prog_save_btn" +
              (saveUnclickable ? " vt_save_disabled" : "")
            }
            onClick={() => saveVirtualObj()}
          >
            {showConfirmation ? "Saved!" : "Save"}
          </div>
        </div>
        {isInAdd && (
          <>
            <div className="prog_back_icon"></div>
            <div
              className="prog_det_back_text"
              onClick={() => openCloseSubform()}
            >
              Back to Main Details
            </div>
          </>
        )}
      </div>
      <div className="vt_overall">
        {!isInAdd ? (
          <VirtualMainForm
            virtualState={virtualState}
            virtualVal={virtualVal}
            subProbIds={subProbIds}
            predefinedStartPos={predefinedStartPos}
            positionOptions={positionOptions}
            mediaPipePoints={mediaPipePoints}
            joints={joints}
            addStartPosition={addStartPosition}
            getVirtualStates={getVirtualStates}
            handleNewArrVals={handleNewArrVals}
            addConditions={addConditions}
            addExtensions={addExtensions}
            addExerciseStep={addExerciseStep}
            removeExerciseStep={removeExerciseStep}
            errorStep={errorStep}
            openCloseSubform={openCloseSubform}
            addGraphOrAction={addGraphOrAction}
            handleTopVals={handleTopVals}
            data={data}
            handleInputChange={handleInputChange}
            handleAddData={handleAddData}
            handleObjVals={handleObjVals}
            handleArrVals={handleArrVals}
            handleArrSubVals={handleArrSubVals}
          />
        ) : (
          <VirtualSubForm
            virtualState={virtualState}
            mediaPipePoints={mediaPipePoints}
            joints={joints}
            addType={addType}
            stepModified={stepModified}
            addGraphOrAction={addGraphOrAction}
            handleArrSubVals={handleArrSubVals}
            handleGraphicPoints={handleGraphicPoints}
            handleGraphicType={handleGraphicType}
            handleGraphicStyle={handleGraphicStyle}
            handleActionObjectNodes={handleActionObjectNodes}
          />
        )}
      </div>
      {errorPopUp && (
        <div className="prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default VirtualBuilder;
